"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userStatusNeoDark = exports.userStatusNeoLight = exports.userStatusNovoDark = exports.userStatusNovo = exports.userStatus = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const userStatus = {
    sizeSmall: '12px',
    sizeLarge: '20px',
    borderColorAvailable: color_const_1.default.white,
    borderColorAway: color_const_1.default.white,
    borderColorBusy: color_const_1.default.white,
    borderColorWrapUp: color_const_1.default.white,
    borderColorDoNotDisturb: color_const_1.default.white,
    borderColorOffline: color_const_1.default.white,
    borderColorOnBreak: color_const_1.default.white,
    borderColorOnCall: color_const_1.default.white,
    borderColorWorkingOffline: color_const_1.default.white,
    colorAvailable: light.statusAvailable01,
    colorAway: light.statusAway01,
    colorBusy: light.statusBusy01,
    colorWrapUp: light.statusWrapup01,
    colorDoNotDisturb: light.statusBusy01,
    colorOffline: light.statusOffline01,
    colorOnBreak: light.statusOffline01,
    colorOnCall: light.statusBusy01,
    colorWorkingOffline: light.statusAway01,
};
exports.userStatus = userStatus;
const userStatusNovo = {
    ...userStatus,
};
exports.userStatusNovo = userStatusNovo;
const userStatusNovoDark = {
    ...userStatus,
    colorAvailable: dark.statusAvailable01,
    colorAway: dark.statusAway01,
    colorBusy: dark.statusBusy01,
    colorWrapUp: dark.statusWrapup01,
    colorDoNotDisturb: dark.statusBusy01,
    colorOffline: dark.statusOffline01,
    colorOnBreak: dark.statusOffline01,
    colorOnCall: dark.statusBusy01,
    colorWorkingOffline: dark.statusAway01,
};
exports.userStatusNovoDark = userStatusNovoDark;
const userStatusNeoLight = {
    ...userStatusNovo,
    colorAvailable: neoLight.statusAvailable01,
    colorAway: neoLight.statusAway01,
    colorBusy: neoLight.statusBusy01,
    colorWrapUp: neoLight.statusWrapup01,
    colorDoNotDisturb: neoLight.statusBusy01,
    colorOffline: neoLight.statusOffline01,
    colorOnBreak: neoLight.statusOffline01,
    colorOnCall: neoLight.statusBusy01,
    colorWorkingOffline: neoLight.statusAway01,
};
exports.userStatusNeoLight = userStatusNeoLight;
const userStatusNeoDark = {
    ...userStatusNovoDark,
    colorAvailable: neoDark.statusAvailable01,
    colorAway: neoDark.statusAway01,
    colorBusy: neoDark.statusBusy01,
    colorWrapUp: neoDark.statusWrapup01,
    colorDoNotDisturb: neoDark.statusBusy01,
    colorOffline: neoDark.statusOffline01,
    colorOnBreak: neoDark.statusOffline01,
    colorOnCall: neoDark.statusBusy01,
    colorWorkingOffline: neoDark.statusAway01,
};
exports.userStatusNeoDark = userStatusNeoDark;
